import React, {Component} from "react"
import {NavLink} from "react-router-dom"

import {IconLabel} from "~/components/"

export default class NavigationListLink extends Component {
  render() {
    return (
      <NavLink {...this.props}>
        <IconLabel i={this.props.icon}>{this.props.children}</IconLabel>
      </NavLink>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/navigations/NavigationListLink.js